// extracted by mini-css-extract-plugin
export var menuItem = "s_qV d_fW d_bw d_bz d_bL d_bb";
export var menuItemSub = "s_qW d_W d_bw d_bL";
export var menuMainLink = "s_qX d_fX d_dx";
export var menuLink = "s_qY d_fX d_dx";
export var Link = "s_qZ v_qZ v_q1 v_rl";